module.exports = __webpack_public_path__ + "img/9F886D_362F25_E8C9A4_5C4C3C-256px.07375f9c.png";